import { Avatar, Box, Button } from "@mui/material";
import { isNil } from "lodash";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../app/AppContextProvider";


const LoginCard = () => {

    let context = useAppContext();
    let navigate = useNavigate();
    context.checkTokenExpirationDate();

    return <Box display="flex">
        {context.isAuthenticated && !isNil(context.user) && <Box display={"flex"} alignItems={"center"} flexDirection={"row"}>
            <Box marginRight={"5px"}>Welcome {context.user?.username}</Box>
            <Avatar />
            <Button onClick={() => context.logout()}>Logout</Button>
        </Box>}
        {(!context.isAuthenticated || isNil(context.user)) && <Button onClick={() => navigate("/login")}>Login</Button>}
    </Box>
}

export default LoginCard